import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Services from './pages/Services/Services';
import Auth from './pages/Auth/Auth';
import AuthCallback from './pages/Auth/AuthCallback';
import Checkout from './pages/Checkout/Checkout';
import FAQ from './pages/FAQ/FAQ';
import Verification from './pages/Verification/Verification';
import Profile from './pages/Profile/Profile';
import History from './pages/History/History';
import CryptoPayment from './pages/CryptoPayment/CryptoPayment';
import LongTermRental from './pages/LongTermRental/LongTermRental';
import Contact from './pages/Contact/Contact';
import ServicesLayout from './components/ServicesLayout/ServicesLayout';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="app">
            <Header />
            <main className="app-main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route element={<ServicesLayout />}>
                  <Route path="/services" element={<Services />} />
                  <Route path="/long-term" element={<LongTermRental />} />
                </Route>
                <Route path="/auth" element={<Auth />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/auth/success" element={<AuthCallback />} />
                <Route path="/pricing" element={<Services />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/verification" element={<Verification />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/history" element={<History />} />
                <Route path="/crypto-payment" element={<CryptoPayment />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
